<template>
  <v-form ref="rideTypeForm" v-model="valid">
    <v-layout style="width: 100%" row wrap pb-2>
       <v-flex xs12 >
        <v-checkbox v-model="arttt.app" label="Available for App"/>
        <v-checkbox v-model="arttt.web"  label="Available for Web"/>
      </v-flex>
      <v-flex xs12 md12 pb-1>
        <h4 class="grey--text text--darken-1">Tariff</h4>
      </v-flex>
      <v-flex xs3 md3 px-2>
        <v-text-field
          :error-messages="errorForField('base_fare')"
          :rules="tariffRules.base_fare"
          v-model="arttt.tariff.base_fare"
          prefix="£"
          type="number"
          class="noStepNumber"
          label="Base Fare"
          @input="resetError('base_fare')"
        />
      </v-flex>
      <v-flex xs3 md3 px-2>
        <v-text-field
          :error-messages="errorForField('per_mile_fare')"
          :rules="tariffRules.per_mile_fare"
          v-model="arttt.tariff.per_mile_fare"
          prefix="£"
          type="number"
          class="noStepNumber"
          label="Per Mile Fare"
          @input="resetError('per_mile_fare')"
        />
      </v-flex>
      <v-flex xs3 md3 px-2>
        <v-text-field
          :error-messages="errorForField('per_minute_fare')"
          :rules="tariffRules.per_minute_fare"
          v-model="arttt.tariff.per_minute_fare"
          prefix="£"
          type="number"
          class="noStepNumber"
          label="Per Minute Fare"
          @input="resetError('per_minute_fare')"
        />
      </v-flex>
      <!-- <v-flex xs3 md3 px-2>
        <v-text-field
          :error-messages="errorForField('additional_charge')"
          :rules="tariffRules.additional_charge"
          v-model="arttt.tariff.additional_charge"
          prefix="£"
          type="number"
          class="noStepNumber"
          label="Additional Charge"
          @input="resetError('additional_charge')"
        /> -->
      <v-flex xs3 md3 px-2>
        <v-text-field
          :error-messages="errorForField('waiting_time_fee')"
          :rules="tariffRules.waiting_time_fee"
          v-model="arttt.tariff.waiting_time_fee"
          prefix="£"
          type="number"
          class="noStepNumber"
          label="Waiting Time Fee"
          @input="resetError('waiting_time_fee')"
        />
      </v-flex>
       <v-flex xs3 md3 px-2>
        <v-text-field
          :error-messages="errorForField('minimum_fare')"
          :rules="tariffRules.minimum_fare"
          v-model="arttt.tariff.minimum_fare"
          prefix="£"
          type="number"
          class="noStepNumber"
          label="Minimum Fare"
          @input="resetError('minimum_fare')"
        />
      </v-flex>
      </v-flex>
            <h4 class="grey--text text--darken-1">Current Modifiers -&nbsp;</h4>
            <h5 class="nobold grey--text text--darken-1">
              Drag and drop to re-order
            </h5>
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              class="text-none pa-1"
              flat
              @click="addTariffModifier()"
              >Add Tariff Modifier</v-btn
            >
          </v-layout>
        <v-flex v-if="arttt.id != null" pt-2>
          <TariffModifierList
            :modifiers="arttt.tariff.modifiers"
            @edit="editTariffModifier($event)"
            @orderChange="changeModifierOrder($event)"
          />
        </v-flex>
      <v-layout column>
        <v-flex pt-3 xs12>
          <v-btn @click="upsert">{{ this.arttt.id == null ? 'Save' : 'Update'}}</v-btn>
          </v-flex>
        <v-flex xs12>
          <TariffModifierForm
          v-if="showModifierDialog"
          ref="tariffModifierForm"
          :show="showModifierDialog"
          :modifierData="tariffModifierData"
          :errors="errors.tariff ? errors.tariff.modifiers[modifierIndex] : {}"
          @cancel="cancelTariffModifier()"
          @save="saveTariffModifier($event)"
          @snackbar="showSnackbar($event.message, $event.colour)"
        />
        </v-flex>
      </v-layout>
       
    
  </v-form>
</template>

<script>


import axios from "axios";
axios.defaults.withCredentials = true;

import FileInput from "@/components/widget/input/FileInput.vue";

import TariffModifierForm from "@/components/settings/pricing/TariffModifierForm.vue";
import TariffModifierList from "@/components/settings/pricing/TariffModifierList.vue";

export default {
  name: "availability_region_ride_type_form",
  components: {
    FileInput,
    TariffModifierForm,
    TariffModifierList,
  },
  props: {
    arttt: Object,
    disabled: Boolean,
  },
  beforeMount() {
  },
  data: function () {
    return {
      valid: false,
      rideType: Object,
      tariff: Object,
      tariffRules: {
        base_fare: [
          (v) => !!v || v == 0 || "Base fare is required",
          (v) => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
        ],
        per_mile_fare: [
          (v) => !!v || v == 0 || "Per mile fare is required",
          (v) => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
        ],
        per_minute_fare: [
          (v) => !!v || v == 0 || "Per minute fare is required",
          (v) => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
        ],  
        waiting_time_fee: [
          (v) => !!v || v == 0 || "Waiting time fee is required",
          (v) => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
        ],
        minimum_fare: [
          (v) => !!v || v == 0 || "Minimum fare is required",
          (v) => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
        ],
        additional_charge: [
          (v) => !!v || v == 0 || "Additional charge is required",
          (v) => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
        ],
      },
      errors: {},
      showModifierDialog: false,
      tariffModifierData: {},
      editModifierIndex: -1,
    };
  },
  methods: {
    create: async function () {
      let self = this;
      let url = `${this.$store.state.apiUrl}/availability_region/tariffs/create`;


      var arttt = JSON.parse(JSON.stringify(this.arttt));

      arttt.tariff.base_fare = Math.round(arttt.tariff.base_fare * 100);
      arttt.tariff.per_mile_fare = Math.round(arttt.tariff.per_mile_fare * 100);
      arttt.tariff.per_minute_fare = Math.round(arttt.tariff.per_minute_fare * 100);
      arttt.tariff.additional_charge = arttt.tariff.additional_charge * 100;
      arttt.tariff.waiting_time_fee = arttt.tariff.waiting_time_fee * 100;
      arttt.tariff.minimum_fare = Math.round(arttt.tariff.minimum_fare * 100);
      
      axios({
        url: url,
        method: "post",
        data: arttt,
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(function (response) {
          console.log(response.data.errors);
          if (response.data.errors) {
            self.errors = response.data.errors;
            self.snackbarMessage =
              "Error adding ride type, please check the form";
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else if (response.data.error != "no_error") {
            self.snackbarMessage =
              "Error adding ride type: " + response.data.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
            console.log(response.data.error);
          } else {
            /*
          const userID = response.data.user.id;
          self.$router.push('../customer/view/' + userID);
          */
          }
        })
        .catch(function (error) {
          console.log(error);
          self.snackbarMessage = "Network error: " + error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
  
    },
    update: async function () {
      let self = this;
      let url = `${this.$store.state.apiUrl}/availability_region/tariffs/updateTariff`;

      var tariff = JSON.parse(JSON.stringify(this.arttt.tariff));

      tariff.base_fare = Math.round(tariff.base_fare * 100);
      tariff.per_mile_fare = Math.round(tariff.per_mile_fare * 100);
      tariff.per_minute_fare = Math.round(tariff.per_minute_fare * 100);
      tariff.additional_charge = tariff.additional_charge * 100;
      tariff.waiting_time_fee = tariff.waiting_time_fee * 100
      tariff.minimum_fare = tariff.minimum_fare * 100
      
      tariff.modifiers.forEach(function (modifier) {
        modifier.base_fare = Math.round(modifier.base_fare * 100);
        modifier.per_mile_fare = Math.round(modifier.per_mile_fare * 100);
        modifier.per_minute_fare = Math.round(modifier.per_minute_fare * 100);
        modifier.additional_charge = Math.round(
          modifier.additional_charge * 100
        );
         modifier.minimum_fare = Math.round(
          modifier.minimum_fare * 100
        );
         modifier.waiting_time_fee = Math.round(
          modifier.waiting_time_fee * 100
        );
      });

      axios({
        url: url,
        method: "post",
        data: {tariff: tariff, app: this.arttt.app, web: this.arttt.web, availability_region_ride_type_tariff_id: this.arttt.id},
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(function (response) {
          console.log(response.data.errors);
          if (response.data.errors) {
            self.errors = response.data.errors;
            self.snackbarMessage =
              "Error adding ride type, please check the form";
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else if (response.data.error != "no_error") {
            self.snackbarMessage =
              "Error adding ride type: " + response.data.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
            console.log(response.data.error);
          } else {
            /*
          const userID = response.data.user.id;
          self.$router.push('../customer/view/' + userID);
          */
          }
        })
        .catch(function (error) {
          console.log(error);
          self.snackbarMessage = "Network error: " + error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
  
    },
    upsert: function() {
      if (this.arttt.id == null) {
        this.create();
      } else {
        this.update();
      }
    },
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function () {
      this.$refs.rideTypeForm.validate();
    },
    handleImageInput: function (file) {
      this.resetError("image");
      this.$emit("imageInput", file);
    },
    handleAlternativeImageInput: function (file) {
      this.resetError("alternative_image");
      this.$emit("alternativeImageInput", file);
    },
    addTariffModifier: function () {
      this.tariffModifierData = {
        name: "",
        //Default to last priority
        priority: this.arttt.tariff.modifiers.length + 1,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        bank_holiday: false,
        hour_period_start: "",
        hour_period_end: "",
        day_period_start_date: "",
        day_period_start_month: "",
        day_period_start_time: "",
        day_period_end_date: "",
        day_period_end_month: "",
        day_period_end_time: "",
        base_fare: "",
        per_mile_fare: "",
        per_minute_fare: "",
        additional_charge: "",
      };

      this.modifierIndex = -1;
      this.showModifierDialog = true;
    },
    cancelTariffModifier: function () {
      this.showModifierDialog = false;
      this.modifierIndex = -1;
    },
    saveTariffModifier: function (modifier) {
      if (this.modifierIndex == -1) {
        this.arttt.tariff.modifiers.push(modifier);
      } else {
        //https://vuejs.org/2016/02/06/common-gotchas/
        //this.tariff.modifiers[this.modifierIndex] = modifier;
        this.arttt.tariff.modifiers.splice(this.modifierIndex, 1, modifier);
      }
      this.showModifierDialog = false;
      this.modifierIndex = -1;
    },
    editTariffModifier: function (index) {
      this.tariffModifierData = Object.assign({}, this.arttt.tariff.modifiers[index]);
      this.modifierIndex = index;
      this.showModifierDialog = true;
    },
    changeModifierOrder: function (newModifiers) {
      for (let i = 0; i < newModifiers.length; i++) {
        newModifiers[i].priority = i + 1;
      }
      this.arttt.tariff.modifiers = newModifiers;
      this.arttt.tariff.modifiers.sort(function (a, b) {
        return a.priority - b.priority;
      });
    },
  },
  watch: {
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
  },
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>